import ViewAuthLogin from "../views/ViewAuthLogin.vue"

export default [
	{
		path: "/login",
		component: ViewAuthLogin,
		name: "ViewAuthLogin",
		props: true,
		meta: {}
	}
]
